import React, {Component} from 'react'
import { inject, observer } from "mobx-react";
import Switch from 'react-toggle-switch'

@inject("CheckInStore")
@observer
class ToggleCheckIn extends Component {
  state = {
    isReturn: false
  }
  toggleNav = (e) => {
    const {CheckInStore} = this.props
    e.preventDefault()
    CheckInStore.isReturn = !CheckInStore.isReturn
  }
  
  componentDidMount = () => {
    const {CheckInStore} = this.props
    CheckInStore.isReturn = CheckInStore.checkinData.return_only
  }
  
  render() {
    const {CheckInStore} = this.props
    return (
        <Switch className={this.props.className} onClick={this.toggleNav} on={CheckInStore.isReturn}/>
    )
  }
}


export default ToggleCheckIn


// WEBPACK FOOTER //
// ./src/components/checkIn/ToggleCheckIn.js